import { withMotion } from '@hoc/withMotion';
import { useHoverIntent } from '@hooks/useHoverIntent';
import ChevronDown from '@img/icons/angle-down.svg';
import * as React from 'react';
import DesktopNavigationDropdown from '../DesktopNavigationDropdown/DesktopNavigationDropdown';
import S from './DesktopNavigation.styles';
import { linkAria } from '@helpers/utils';
const show = {
    opacity: 1,
    display: 'block',
};
const hide = {
    opacity: 0,
    transitionEnd: {
        display: 'none',
    },
};
const NavItem = ({ setCurrentId, active, ...props }) => {
    const { ref: anchorRef } = useHoverIntent({
        onHover() {
            setCurrentId(props.id);
        },
        onBlur() {
            setCurrentId('');
        },
    });
    return (React.createElement(S.Item, { ref: anchorRef },
        React.createElement(S.Link, { "aria-current": active, "aria-label": linkAria(props.title ?? '', props.target, props.translations && props.translations['lcci.link.newtab']), href: props.url },
            props.title,
            " ",
            props.children && React.createElement(ChevronDown, null)),
        props.children && (React.createElement(S.DropdownWrapper, { animate: active ? show : hide },
            React.createElement(DesktopNavigationDropdown, { item: props })))));
};
const DesktopNavigation = (props) => {
    const [currentId, setCurrentId] = React.useState('');
    return (React.createElement(S.Container, null,
        React.createElement(S.List, null, props.items.map((item) => (React.createElement(NavItem, { key: item.id, ...item, active: currentId === item.id, setCurrentId: setCurrentId, translations: props.translations }))))));
};
export default withMotion(DesktopNavigation);
